/*
 *  -----------------------------------------------------------------------
 *    <copyright file="preview-expandable.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Divider } from '@mui/material';
import React from 'react';

import { useBoolean } from 'hooks';
import { Accordion, AccordionDetails, AccordionSummary } from 'views/components/core/expansion-panel';

import './preview-expandable.scss';
import { textToId } from '@utils/automation-test-helpers';

const PreviewExpandable = ({
    customKey,
    isExpanded,
    children,
    header,
    detailsClassName,
}: {
    customKey?: string;
    isExpanded: boolean;
    children?: any;
    header: any;
    detailsClassName?: string;
}) => {
    const expanded = useBoolean(isExpanded);
    const headerString = typeof header === 'string' ? textToId(header ?? '') : customKey;
    return (
        <Accordion
            expanded={expanded.value}
            key={customKey}
            className="expandable-panel preview-report"
            data-testid={`expansion-panel-${headerString}`}
            slotProps={{ heading: { component: 'div' } }}
        >
            <AccordionSummary className="expand-summary">
                <div
                    className="header-content"
                    onClick={() => {
                        if (children) {
                            expanded.setValue(!expanded.value);
                        }
                    }}
                >
                    <FontAwesomeIcon
                        icon={['fal', 'chevron-down']}
                        className={`icon-arrow ${expanded.value && children ? 'expanded' : ''}`}
                    />
                    <div className="header">{header}</div>
                </div>
            </AccordionSummary>

            {Boolean(children) && (
                <>
                    <Divider
                        classes={{
                            root: 'list-content-divider',
                        }}
                    />
                    <div className="wrapper">
                        <AccordionDetails className={detailsClassName || 'details-wrapper'}>
                            {children}
                        </AccordionDetails>
                    </div>
                </>
            )}
        </Accordion>
    );
};

export default PreviewExpandable;
